module.exports = __webpack_public_path__ + "img/icb-del-Adv-m@3x.84de4ac4.png";